module.exports = __webpack_public_path__ + "static/media/kv-th.f523b8b7.jpg";